const DELAY_TO_SHOW = 200;
const RESPONSIVE_BREAKPOINT = 960;

const menu = document.getElementById('megamenu');
const drawer = document.getElementById('drawer');
const drawerTrigger = document.getElementById('drawer-trigger');
const dropdownLayer = document.querySelector('.Megamenu__DropdownLayer');


// global interaction

const setArrows = () => {
    document.querySelectorAll('.Megamenu__Link').forEach(link => {
    
        const linkListArrow = link.querySelector('.Link__Sublist__Arrow');
        const arrowPosition = Math.round(link.getBoundingClientRect().left + link.getBoundingClientRect().width/2);
        
        if(linkListArrow) {
            linkListArrow.style.left = (arrowPosition - 20) + 'px';
        }
    });
}

const playVideo = (section,action) => {

    const videos = section.querySelectorAll('iframe');

    if(videos.length > 0) {
        videos.forEach(video => {
            if(action == 'play')
                video.setAttribute('src',video.src+'?autoplay=1');
            else
                video.setAttribute('src',video.src.replace('?autoplay=1',''));
        }); 
    }
}

const setMenuTriggers = () => {

    const isResponsive = window.innerWidth <= RESPONSIVE_BREAKPOINT;

    if(!isResponsive) {
        document.querySelectorAll('.Megamenu__Link').forEach(link => {
            link.onmouseenter = () => {
                link.dataset.menuIsActive = true;    
                setTimeout(() => {
                    if(link.dataset.menuIsActive === 'true') {
                        dropdownLayer.style.height = (link.querySelector('.Link__Sublist').getBoundingClientRect().height - 32) + 'px';
                        dropdownLayer.style.opacity = 1;
                        setTimeout(() => {
                            playVideo(link.querySelector('.Link__Sublist'),'play');
                            link.querySelector('.Link__Sublist').classList.add('Link__Sublist--on');
                        },200);
                    }
                },DELAY_TO_SHOW);
            }
            link.onmouseleave = () => {
                link.dataset.menuIsActive = false;  
                setTimeout(() => {
                    if(link.dataset.menuIsActive === 'false') {
                        link.querySelector('.Link__Sublist').classList.remove('Link__Sublist--on');
                        playVideo(link.querySelector('.Link__Sublist'),'stop');
                        dropdownLayer.style.height = 0;
                        dropdownLayer.style.opacity = 0;
                    }
                },DELAY_TO_SHOW);
            }
        });
    }
}

// sticky interaction

const stickyMenu = () => {

    const menuProps = { height: 166 }; //menu.getBoundingClientRect();
    const isMobile = (window.innerWidth <= RESPONSIVE_BREAKPOINT);

    if(isMobile) return false;

    if(document.documentElement.scrollTop >= menuProps.height) {
        // document.body.style.paddingTop = menuProps.height + 'px';
        menu.classList.add('Megamenu--sticky');
    }
    else {
        // document.body.style.paddingTop = '0px';
        menu.classList.remove('Megamenu--sticky');
    }
}

// drawer (only mobile)

const setDrawer = () => {

    const resetDrawerSections = () => {
        document.querySelectorAll('.Drawer__Section--on').forEach(section => {
            section.classList.remove('Drawer__Section--on');
        });
    }
    
    drawerTrigger.onclick = () => {
        drawer.classList.add('Drawer--on');
        document.body.style.overflow = 'hidden';
    };
    
    document.querySelectorAll('[data-action="close-drawer"]').forEach(element => {
        element.onclick = () => {
            drawer.classList.remove('Drawer--on');
            document.body.style.overflow = 'auto';
            resetDrawerSections();
        }
    });
    
    document.querySelectorAll('.Drawer__Link span').forEach(link => {
        link.onclick = () => {
            link.parentNode.querySelector('.Drawer__Section').classList.add('Drawer__Section--on');
        }
    });
    
    document.querySelectorAll('[data-action="back-drawer"]').forEach(element => {
        element.onclick = () => {
            resetDrawerSections();
        }
    });
}

setMenuTriggers();
setArrows();
setDrawer();

window.addEventListener('resize',setArrows);
window.addEventListener('resize',setMenuTriggers);
// window.addEventListener('scroll',stickyMenu);